// import emojiList from 'file-loader!emoji-datasource/emoji.json';
import emojiList from 'emoji-datasource/emoji.json';

export default emojiList;
